import { registerLocaleData } from "@angular/common";
import localeDe from "@angular/common/locales/de";
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { AppGlobals } from "../../app.globals";
import { HttpClient } from "@angular/common/http";
import * as ExcelJS from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
import notify from "devextreme/ui/notify";
import {
  DxButtonModule,
  DxTreeListModule,
  DxTemplateModule,
  DxPopupModule,
  DxTextBoxModule,
  DxDataGridModule,
  DxDataGridComponent,
  DxCheckBoxModule,
  DxContextMenuModule,
} from "devextreme-angular";
import JSZip from "jszip";

interface TemplateFile {
  taskId: Number;
  file: File;
}

registerLocaleData(localeDe);

import { CommonModule } from "@angular/common";
/* import { AppComponentsModule } from 'src/app/components/app.components.module'; */
import { __values } from "tslib";
import { ProjectCostsService } from "src/app/services/project-costs.service";
import { ConfigService } from "src/app/services/config.service";
import { LoggingService } from "src/app/services/logging.service";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import {
  beauftragtFileSlug,
  beauftragtRequestValue,
} from "src/app/constants/beauftragt-filter";
import {
  amountBasisFileSlug,
  amountBasisIsNetto,
} from "src/app/constants/amount-basis";
import { GpdFilter } from "src/app/components/gpd-filter/gpd-filter";
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
import {
  AMOUNT_BASIS_FILTER_ITEMS,
  BEAUFTRAGT_FILTER_ITEMS,
  FilterItem,
  MY_VIEW_FILTER_ITEMS,
  amountBasisSelectionToCode,
  beauftragtCodeToSelection,
  beauftragtSelectionToCode,
  readStoredMyView,
} from "src/app/constants/cost-overview-filters";


import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
@Component({
    selector: "app-ProjectCostOverview",
    templateUrl: "./ProjectCostOverview.page.html",
    styleUrls: ["./ProjectCostOverview.page.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        DxCheckBoxModule,
        DxButtonModule,
        /*     AppComponentsModule, */
        DxTreeListModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxPopupModule,
        DxDataGridModule,
        DxContextMenuModule,
        GpdButtonComponent,
        GpdFilter,
        SvgIconComponent
    ]
})
export class ProjectCostOverview implements OnInit, OnDestroy {

  currentPageTitle: any = $localize`:@@projectCostOverview:Project Cost Overview`;
  @ViewChild("treelist") taskConfigList;
  //@ViewChild(DxTreeListComponent, { static: false }) treelist: DxTreeListComponent;
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  dxgrid: DxDataGridComponent;

  users: any;
  noData: string = $localize`:@@noData:No Data`;
  contentLoadedVisible: boolean = false;
  contentLoaded: boolean = false;

  projectData = new Array();
  treeLists: any = [];
  listBaukostenÜbersicht: any = [];
  projectList: any = [];
  allDetailsPopup: any = [];

  /**
   * Explicit rather than relying on the default: the popup sets `container`, so its position
   * resolves against that container instead of the viewport. A plain object literal in the
   * template would be a new reference on every change detection pass, which DevExtreme would
   * keep re-applying, so it is held as a field.
   */
  readonly centerOnScreen = { my: "center", at: "center", of: window };

  selectedItem: any = $localize`:@@projectCostOverview:Project Costs Overview`;
  dataSource: any[] = [];
  selectedCosts: any = [];
  storedColumnDate: any = [];
  cellDataStored: any = [];
  selectedShift: string = "";
  linkedCosts: any = [];
  showRelatedCosts: boolean = false;
  showGrid: boolean = false;

  columnData: any = {};
  currentDate: Date = new Date();
  today = this.currentDate.toISOString().slice(0, 10);
  searchTerm: string = AppGlobals.searchPanelText;
  returnedProjectsList: any = "";

  gridVisible: boolean = false;

  allDates: string[];
  positionOf: string;
  popupVisible = false;
  title: string;
  popupTitle: string = $localize`:@@selectCostsToMove:Select Costs to Move`;
  currentWeek = "";

  filteredProjectList: any = [];
  dates: string[] = [];
  totals: any = {};
  constructor(
    private configService: ConfigService,
    private projectCostsService: ProjectCostsService,
    private loggingService: LoggingService,
    private router: Router,
    private appGlobals: AppGlobals,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private activityLog: ActivityLogService
  ) {
    providers: [{ provide: localeDe, useValue: "de-DE" }];
    this.getPageData();
  }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.COST_OVERVIEW });
    const currentDate = new Date();
    const mondayDate = new Date(
      currentDate.getTime() - currentDate.getDay() * 86400000 + 86400000,
    );

    this.currentWeek = mondayDate
      .toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .split(".")
      .join("-");

    this.appGlobals.SetGlobalMenuIndex(5);

    AppGlobals.clearBreadCrumbInLocalStorage();
    this.appGlobals.$headerTitle.next(
      $localize`:@@projectCostOverview:Project Cost Overview`,
    );
  }

  private static readonly BEAUFTRAGT_STORAGE_KEY = "projectCostOverviewBeauftragt";
  private static readonly AMOUNT_BASIS_STORAGE_KEY = "projectCostOverviewAmountBasis";
  private static readonly MY_COSTS_STORAGE_KEY = "projectCostOverViewMyTasks";

  /**
   * Restores a filter. Read as a field initialiser, which runs before the constructor body:
   * the first getPageData call then already carries the stored position, rather than the grid
   * loading unfiltered and the bar claiming otherwise. What the filter no longer offers falls
   * back to its default. Codes, not tick arrays, are what is stored - see cost-overview-filters.
   */
  private static readStoredSwitch(
    key: string,
    options: FilterItem[],
    fallback: number,
  ): number {
    try {
      const stored = Number(localStorage.getItem(key));
      return options.some((o) => o.value === stored) ? stored : fallback;
    } catch {
      return fallback;
    }
  }

  private static storeSwitch(key: string, value: number | string): void {
    try {
      localStorage.setItem(key, String(value));
    } catch {
      // A full or blocked localStorage must not stop the filter from applying.
    }
  }

  /** Empty = every cost. The planning costs' "Meine Ansicht" pill (#4926). */
  readonly myViewItems: FilterItem[] = MY_VIEW_FILTER_ITEMS;
  myViewFilter: number[] = readStoredMyView(
    localStorage.getItem(ProjectCostOverview.MY_COSTS_STORAGE_KEY),
  );

  /** Both ticked = "alle", which is the default and reads as inactive. */
  readonly beauftragtItems: FilterItem[] = BEAUFTRAGT_FILTER_ITEMS;
  beauftragtFilter: number[] = beauftragtCodeToSelection(
    ProjectCostOverview.readStoredSwitch(
      ProjectCostOverview.BEAUFTRAGT_STORAGE_KEY,
      BEAUFTRAGT_FILTER_ITEMS,
      0,
    ),
  );

  /**
   * 0 = Brutto, 1 = Netto. Drives the grid, the details popup and the export alike.
   * A display mode rather than a filter: it always holds one of the two, so neither position
   * counts as "filtering" and the pill never paints itself active.
   */
  readonly amountBasisItems: FilterItem[] = AMOUNT_BASIS_FILTER_ITEMS;
  amountBasis: number[] = [
    ProjectCostOverview.readStoredSwitch(
      ProjectCostOverview.AMOUNT_BASIS_STORAGE_KEY,
      AMOUNT_BASIS_FILTER_ITEMS,
      0,
    ),
  ];

  /** The 0/1/2 codes the request payloads and export filenames have always spoken. */
  private get beauftragtCode(): number {
    return beauftragtSelectionToCode(this.beauftragtFilter);
  }

  private get amountBasisCode(): number {
    return amountBasisSelectionToCode(this.amountBasis);
  }

  async setMyViewFilter(value: number[]) {
    this.myViewFilter = value ?? [];
    ProjectCostOverview.storeSwitch(
      ProjectCostOverview.MY_COSTS_STORAGE_KEY,
      this.myViewFilter.join(","),
    );
    await this.applyFilters();
  }

  async setAmountBasis(value: number[]) {
    // nullable=false keeps a value in there; the fallback is belt and braces.
    this.amountBasis = value?.length ? value : [0];
    ProjectCostOverview.storeSwitch(
      ProjectCostOverview.AMOUNT_BASIS_STORAGE_KEY,
      this.amountBasisCode,
    );
    await this.applyFilters();
  }

  /** Costs whose site cost has no Debitor. Kept visible and exportable rather than dropped. */
  private readonly noDebitorLabel = $localize`:@@withoutDebitor:Without Debitor`;
  private static readonly DEBITOR_STORAGE_KEY = "projectCostOverviewExcludedDebitors";
  /** The API spells "no Debitor" as "", which dxTagBox does not handle as a key. */
  private static readonly NO_DEBITOR_KEY = "__ohne_schuldner__";

  private static toRequestNames(debitors: string[]): string[] {
    return (debitors ?? []).map((d) =>
      d === ProjectCostOverview.NO_DEBITOR_KEY ? "" : d,
    );
  }

  /** The grid's costs unpivoted, one per row; the export's list sheet. Same filters as the grid. */
  costItems: any[] = [];

  /** Every Schuldner the API knows, independent of the other filters. */
  debitorOptions: { label: string; value: string }[] = [];
  /**
   * What the tag box shows ticked: every option minus the exclusions. Derived, never stored -
   * storing the ticks instead would hide any Gesellschaft created after the last visit.
   */
  selectedDebitors: string[] = [];
  /** The persisted half, and what the API is actually sent. Empty = show everything. */
  private excludedDebitors: string[] = ProjectCostOverview.readExcludedDebitors();

  private static readExcludedDebitors(): string[] {
    try {
      const raw = JSON.parse(
        localStorage.getItem(ProjectCostOverview.DEBITOR_STORAGE_KEY) ?? "null",
      );
      return Array.isArray(raw) ? raw.filter((d) => typeof d === "string") : [];
    } catch {
      return [];
    }
  }

  /**
   * The tag box this replaced applied on an OK button, so a run of ticks cost one request.
   * The filter popover has no OK - it reports every tick - so the ticks are collected and the
   * refetch waits for a pause instead, rather than firing once per company.
   */
  static readonly DEBITOR_REFETCH_DELAY_MS = 400;
  private debitorRefetchTimer: ReturnType<typeof setTimeout> | null = null;

  setDebitorFilter(value: string[]): void {
    const keys = this.debitorOptions.map((o) => o.value);
    // Unticking everything would read as an empty page for no visible reason; treat it as "all".
    const ticked = value?.length ? value : keys;
    // Only options currently on offer can be judged, so exclusions for Schuldner the filter
    // is not showing (narrowed by Beauftragt or My Costs) are dropped rather than made permanent.
    const excluded = keys.filter((k) => !ticked.includes(k));

    // syncDebitorOptions writes the selection back on every response - without this the pair
    // would refetch each other forever.
    if (ProjectCostOverview.sameKeys(excluded, this.excludedDebitors)) {
      return;
    }

    this.excludedDebitors = excluded;
    this.selectedDebitors = ticked;
    localStorage.setItem(
      ProjectCostOverview.DEBITOR_STORAGE_KEY,
      JSON.stringify(this.excludedDebitors),
    );

    this.cancelDebitorRefetch();
    this.debitorRefetchTimer = setTimeout(() => {
      this.debitorRefetchTimer = null;
      this.applyFilters();
    }, ProjectCostOverview.DEBITOR_REFETCH_DELAY_MS);
  }

  private cancelDebitorRefetch(): void {
    if (this.debitorRefetchTimer) {
      clearTimeout(this.debitorRefetchTimer);
      this.debitorRefetchTimer = null;
    }
  }

  ngOnDestroy(): void {
    this.cancelDebitorRefetch();
  }

  private static sameKeys(a: string[], b: string[]): boolean {
    return a.length === b.length && a.every((k) => b.includes(k));
  }

  /**
   * Every filter here survives a reload, so a narrowed grid can greet someone who has long
   * forgotten setting it. The link is the way back out - same place and wording as the
   * pipeline and project list bars.
   */
  get hasActiveFilters(): boolean {
    // Brutto/Netto is deliberately absent: it is a display mode, always on either way, so it
    // is not something the reset link should offer to clear.
    return (
      this.myViewFilter.length > 0 ||
      this.beauftragtCode !== 0 ||
      this.excludedDebitors.length > 0
    );
  }

  async resetFilters(): Promise<void> {
    if (!this.hasActiveFilters) {
      return;
    }

    // A tick still waiting out its debounce would otherwise land after the reset and undo it.
    this.cancelDebitorRefetch();

    // amountBasis is untouched on purpose: resetting the filters should not quietly change
    // what every figure on screen means.
    this.myViewFilter = [];
    this.beauftragtFilter = beauftragtCodeToSelection(0);
    this.excludedDebitors = [];
    this.selectedDebitors = this.debitorOptions.map((o) => o.value);

    ProjectCostOverview.storeSwitch(ProjectCostOverview.MY_COSTS_STORAGE_KEY, "");
    ProjectCostOverview.storeSwitch(
      ProjectCostOverview.BEAUFTRAGT_STORAGE_KEY,
      0,
    );
    try {
      localStorage.removeItem(ProjectCostOverview.DEBITOR_STORAGE_KEY);
    } catch {
      // Same reasoning as storeSwitch: a blocked store must not block the reset.
    }

    // One round trip for all three, rather than one per filter as the setters would do.
    await this.applyFilters();
  }

  /**
   * Rebuilds the tag box from each response. The exclusions were already sent with the request
   * that produced it, so nothing needs refetching - which is why exclusions are what we persist.
   */
  private syncDebitorOptions(available: string[]): void {
    this.debitorOptions = available.map((name) => ({
      value: name === "" ? ProjectCostOverview.NO_DEBITOR_KEY : name,
      label: name === "" ? this.noDebitorLabel : name,
    }));
    const ticked = this.debitorOptions
      .map((o) => o.value)
      .filter((k) => !this.excludedDebitors.includes(k));
    // Only reassign on a real change, so the widget is not handed a fresh array every response.
    if (!ProjectCostOverview.sameKeys(ticked, this.selectedDebitors)) {
      this.selectedDebitors = ticked;
    }
  }

  async setBeauftragtFilter(value: number[]) {
    // Keep the pill's own ticks, even none: nothing ticked already means "alle" to the request.
    // Writing [1, 2] back desynced the checkbox that was just clicked (its binding never changed).
    this.beauftragtFilter = value ?? [];
    ProjectCostOverview.storeSwitch(
      ProjectCostOverview.BEAUFTRAGT_STORAGE_KEY,
      this.beauftragtCode,
    );
    await this.applyFilters();
  }

  /** Refetch and redraw. Every filter in the bar ends here, so they all behave alike. */
  private async applyFilters(): Promise<void> {
    await this.getPageData();
    await this.getFilteredAndSortedData();
    this.dataGrid.instance.refresh();
  }

  async getPageData(excludedDebitors: string[] = this.excludedDebitors) {
    return this.projectCostsService
      .getProjectCostOverview({
        myView: this.myViewFilter,
        beauftragt: beauftragtRequestValue(this.beauftragtCode),
        excludedDebitorNames:
          ProjectCostOverview.toRequestNames(excludedDebitors),
        netto: amountBasisIsNetto(this.amountBasisCode),
      })
      .then(
        (result) => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } else {

            this.syncDebitorOptions(result.debitors ?? []);
            this.costItems = result.items ?? [];

            result.costs.forEach(element => {
              element['summaryId'] = 1;
            });

            if (result && result.costs) {
              let projList = result.costs;
              projList.forEach((project) => {
                // Merge the date:amount pairs from costsDict into the project object
                for (const [key, value] of Object.entries(project.costDict)) {
                  const newKey = key.replace(/\./g, "-");
                  project[newKey] = value;
                }
              });

              for (let i = 0; i < projList.length; i++) {
                projList[i].key = projList[i].groupDisplay.projectName;
                // projList[i].id = projList[i].groupDisplay.projectId;
              }

              // projList = this.getFilteredAndSortedData();

              /*             projList.forEach(projectGroup => {
                          projectGroup.items.forEach(project => {
                            this.projectList.push(project)
                          })
                        }) */
              this.projectList = projList;
              this.getAllDates();
              this.projectList.forEach((projectItem) => {
                this.dates.forEach((dateItem) => {
                  if (
                    !projectItem.hasOwnProperty(dateItem) &&
                    dateItem !== "id" &&
                    dateItem !== "details" &&
                    dateItem !== "categoryId" &&
                    dateItem !== "groupDisplay" &&
                    dateItem !== "key" &&
                    dateItem !== "costDict" &&
                    dateItem !== "category" &&
                    dateItem !== "date" &&
                    dateItem !== "cost" &&
                    dateItem !== "summaryId"
                  ) {
                    projectItem[dateItem] = null;
                  }
                });
              });
              this.contentLoadedVisible = true;
              this.contentLoaded = true;
              this.gridVisible = true;
              // Deliberately not awaited, but the rejection must be absorbed: any caller that
              // refreshes again, or any change detection pass that re-applies [dataSource],
              // cancels this one and would otherwise leave an unhandled "canceled" rejection.
              this.dataGrid.instance.refresh().then(
                () => {
                  // this.calculateTotals();
                },
                () => {
                  // superseded by a newer load, which is the one that matters
                },
              );
              this.ds = this.projectList;
            }
            return this.getUserList();


          }
        },
        (error) => {
          AppGlobals.ShowErrorMessage(error);
        },
      );
  }

  private applyUserDisplayNames(): void {
    for (let i = 0; i < this.projectList.length; i++) {
      for (let a = 0; a < this.users.length; a++) {
        if (this.projectList[i].details === this.users[a].emailAddress) {
          this.projectList[i].details = this.users[a].displayName;
        }
      }
    }
  }

  getUserList(): Promise<void> {
    // Independent of every cost filter, so it is fetched once rather than on each refetch -
    // the per-Schuldner export loop would otherwise repeat it for every Gesellschaft.
    if (this.users) {
      this.applyUserDisplayNames();
      this.getAllDates();
      return Promise.resolve();
    }
    return this.configService.getListOfUsers({}).then(
      (result) => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.users = result.projectsUsers;

          this.applyUserDisplayNames();
          this.getAllDates();
          this.dataGrid.instance.refresh();
        }
      },
      (error) => {
        AppGlobals.ShowErrorMessage(error);
      },
    );
  }

  getAllDates(): string[] {
    let allDates: any = [];
    this.projectList.forEach((project) => {
      for (const projectKey in project) {
        if (
          project.hasOwnProperty(projectKey) &&
          projectKey !== "id" &&
          projectKey !== "details" &&
          projectKey !== "groupDisplay" &&
          projectKey !== "key" &&
          projectKey !== "costDict" &&
          projectKey !== "category" &&
          projectKey !== "categoryId" &&
          projectKey !== "date" &&
          projectKey !== "cost" &&
          projectKey !== "summaryId"
        ) {
          allDates.push(projectKey);
        }
      }
    });
    const currentDate = new Date();
    const mondayDate = new Date(
      currentDate.getTime() - currentDate.getDay() * 86400000 + 86400000,
    );
    let formattedMondayDate = mondayDate
      .toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .split(".")
      .join("-");

    if (!allDates.includes(formattedMondayDate)) {
      allDates.push(formattedMondayDate);
    }
    const sortedDates = allDates.sort((a, b) => {
      const [dayA, monthA, yearA] = a.split("-").map(Number);
      const [dayB, monthB, yearB] = b.split("-").map(Number);
      if (yearA !== yearB) {
        return yearA - yearB;
      }
      if (monthA !== monthB) {
        return monthA - monthB;
      }
      return dayA - dayB;
    });
    let sortedAndFormattedDates = [];
    sortedDates.forEach((date) => {
      if (!sortedAndFormattedDates.includes(date)) {
        sortedAndFormattedDates.push(date as string);
      }
    });
    this.dates = sortedAndFormattedDates;

    

    /*     this.projectList.forEach(projectItem => {
          this.dates.forEach(dateItem => {
            if (!projectItem.hasOwnProperty(dateItem) && dateItem !== 'id' && dateItem !== 'details' && dateItem !== 'groupDisplay' && dateItem !== 'key' && dateItem !== 'category' && dateItem !== 'date' && dateItem !== 'cost') {
              projectItem[dateItem] = null;
            }
          })
        })
        */

    return sortedAndFormattedDates;
  }

  formatHeaderDate(date: string): string {
    return date.split("-").join(".");
  }

  isDateColumnVisible(date: string): boolean {
    return this.projectList.some((project) => project.hasOwnProperty(date));
  }

  formatEuro(value: any): any {
    if (value === 0 || value == undefined) {
      return "";
    } else {
      return (
        value.toLocaleString("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + " €"
      );
    }
  }

  formatEuroForString(value: any): number {
    return value.toLocaleString("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  getSumForColumn(date: string): number {
    return this.projectList.reduce((acc, curr) => acc + curr[date], 0);
  }
  filterData(searchTerm: string): any[] {
    // Implement your filtering logic here
    // Example: filter the projects based on the gridConnectionName and connectedProjects

    for (let i = 0; i < this.returnedProjectsList.length; i++) {
      if (this.returnedProjectsList[i].gridConnectionName === null) {
        this.returnedProjectsList[i].gridConnectionName = "";
      }
    }

    return this.returnedProjectsList.filter(
      (project) =>
        project.gridConnectionName
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        project.connectedProjects.some((item) =>
          item.projectName.toLowerCase().includes(searchTerm.toLowerCase()),
        ),
    );
  }

  doSearch(e: any): void {
    this.contentLoadedVisible = false;
    this.searchTerm = e.value;
    /*   if (this.searchTerm.length < 2) {
        if (this.treelist) {
          this.treelist.instance.searchByText('');
          this.appGlobals.setSearchPanelText('');
          this.contentLoadedVisible = true;
        }
        return; 
      }*/
    /*  if (this.treelist) {
       this.treelist.instance.searchByText(this.searchTerm);
       this.appGlobals.setSearchPanelText(this.searchTerm);
       this.contentLoadedVisible = true;
     } */

    if (this.searchTerm.length < 2) {
      if (this.dataGrid) {
        this.dataGrid.instance.searchByText("");
        this.appGlobals.setSearchPanelText("");
        this.contentLoadedVisible = true;
      }
      return;
    }
    if (this.dataGrid) {
      this.dataGrid.instance.searchByText(this.searchTerm);
      this.appGlobals.setSearchPanelText(this.searchTerm);
      this.contentLoadedVisible = true;
    }
  }

  setPageSize() {
    const windowHeight = window.innerHeight;
    const pagingHeight = 280;
    const gridHeaderHeight = 30;
    const gridRowHeight = 33.7167;
    const availableHeight = windowHeight - pagingHeight - gridHeaderHeight;
    const pageSize = Math.floor(availableHeight / gridRowHeight);
    return pageSize > 0 ? pageSize : 1;
  }
  showProjektkosten(cellData: any) {
    if (cellData.groupDisplay != undefined) {
      let selectionSiteID = cellData.groupDisplay.siteId;
      let selectionProjectID = cellData.groupDisplay.projectId;
      const url = this.router.serializeUrl(
        this.router.createUrlTree([
          "/site/" +
          selectionSiteID +
          "/project/" +
          selectionProjectID +
          "/project-costs/actual",
        ]),
      );
      window.open(url, "_blank");
    } else {
      if (
        cellData.collapsedItems === null ||
        cellData.collapsedItems === undefined
      ) {
        let selectionSiteID = cellData.items[0].groupDisplay.siteId;
        let selectionProjectID = cellData.items[0].groupDisplay.projectId;
        const url = this.router.serializeUrl(
          this.router.createUrlTree([
            "/site/" +
            selectionSiteID +
            "/project/" +
            selectionProjectID +
            "/project-costs/actual",
          ]),
        );
        window.open(url, "_blank");
      } else {
        let selectionSiteID = cellData.collapsedItems[0].groupDisplay.siteId;
        let selectionProjectID =
          cellData.collapsedItems[0].groupDisplay.projectId;
        const url = this.router.serializeUrl(
          this.router.createUrlTree([
            "/site/" +
            selectionSiteID +
            "/project/" +
            selectionProjectID +
            "/project-costs/actual",
          ]),
        );
        window.open(url, "_blank");
      }
    }
  }

  showContextMenu(e) {
    if (e.columnIndex !== 0 && e.columnIndex !== 1) {
      const cellData = e.row.data;
      const columnDate = e.column.name;
      

      // Base menu items that are always shown
      const baseMenuItems = [
        {
          text: $localize`:@@projectCosts:Project Costs`,
          onItemClick: () => this.showProjektkosten(cellData),
        },
        {
          text: $localize`:@@details:Details`,
          onItemClick: () => this.showDetails(cellData, columnDate),
        },
      ];

      // Check if projectCostId exists to determine if postpone menu should be shown
      const projectCostId = cellData.groupDisplay?.projectCostId ?? null;

      if (projectCostId !== null) {
        // If projectCostId exists, add the postpone menu items
        e.items = [
          ...baseMenuItems,
          ...this.getPostponeMenu(cellData, columnDate),
        ];
      } else {
        // If projectCostId is null, show only base menu items
        e.items = baseMenuItems;
      }
    }
  }

  private getPostponeMenu(cellData: any, columnDate: any): any[] {
    const projectCostId = cellData.groupDisplay?.projectCostId ?? null;
    
    const projectId = cellData.id;
    this.cellDataStored = cellData;
    const [day, month, year] = columnDate.split("-");
    const apiDateTime = `${year}-${month}-${day}`;

    const moveAllCostItem = {
      text: $localize`:@@moveallcost:shift all cost`,
      items: [
        {
          text: $localize`:@@postpone1Week:Postpone 1 Week`,
          onItemClick: () =>
            this.getRelatedCosts(cellData, apiDateTime, projectId, "oneWeek", true),
        },
        {
          text: $localize`:@@postpone4Week:Postpone 4 Weeks`,
          onItemClick: () =>
            this.getRelatedCosts(cellData, apiDateTime, projectId, "fourWeeks", true),
        },
        {
          text: $localize`:@@postpone3Week:Postpone 3 Months`,
          onItemClick: () =>
            this.getRelatedCosts(cellData, apiDateTime, projectId, "threeMonths", true),
        },
      ],
    };

    // If projectCostId is null, return only "move all cost"
    if (projectCostId === null) {
      return [moveAllCostItem];
    }

    // If projectCostId has a value, return both items
    const moveThisCostItem = {
      text: $localize`:@@movethiscost:shift this cost`,
      items: [
        {
          text: $localize`:@@postpone1Week:Postpone 1 Week`,
          onItemClick: () =>
            this.getRelatedCosts(cellData, apiDateTime, projectId, "oneWeek"),
        },
        {
          text: $localize`:@@postpone4Week:Postpone 4 Weeks`,
          onItemClick: () =>
            this.getRelatedCosts(cellData, apiDateTime, projectId, "fourWeeks"),
        },
        {
          text: $localize`:@@postpone3Week:Postpone 3 Months`,
          onItemClick: () =>
            this.getRelatedCosts(
              cellData,
              apiDateTime,
              projectId,
              "threeMonths",
            ),
        },
      ],
    };

    return [moveThisCostItem, moveAllCostItem];
  }

  onPopupHidden() {
    this.selectedCosts = [];
    this.showGrid = false;
  }

  shiftBy(): void {
    const shiftTerms = ["oneWeek", "fourWeeks", "threeMonths"];

    if (this.selectedShift == shiftTerms[0]) {
      this.shiftOneWeek(
        this.cellDataStored,
        this.storedColumnDate,
        this.selectedCosts,
      );
    } else if (this.selectedShift == shiftTerms[1]) {
      this.shiftFourWeek(
        this.cellDataStored,
        this.storedColumnDate,
        this.selectedCosts,
      );
    } else {
      this.shiftThreeMonth(
        this.cellDataStored,
        this.storedColumnDate,
        this.selectedCosts,
      );
    }
  }

  onSelectionChanged(e: any): void {
    const selectedRowsData = e.component.getSelectedRowsData();
    this.selectedCosts = selectedRowsData.map((row) => row.costId);
  }

  shiftOneWeek(cellData: any, columnDate: any, selectedCostIds: any[]) {
    const isMoveAll = !selectedCostIds || selectedCostIds[0] === null;
    let projectCostData = {};

    if (!isMoveAll) {
      projectCostData = {
        projectId: cellData.groupDisplay?.projectId || cellData.id,
        projectCostIds: selectedCostIds,
        columnDate: columnDate,
      };
    } else {
      const source = cellData.groupDisplay
        ? cellData
        : cellData.collapsedItems?.[0] || cellData.items?.[0];

      projectCostData = {
        projectId: source.groupDisplay?.projectId,
        projectCostIds: null,
        columnDate: columnDate,
      };
    }
    this.projectCostsService
      .shiftProjectCostDetailsOneWeek(projectCostData)
      .then(
        (result) => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } else {
            this.getPageData();
            this.dataGrid.instance.refresh();
            this.notifyShiftSummary(selectedCostIds);
            this.showRelatedCosts = false; // Close the popup
            this.selectedCosts = [];
            this.showRelatedCosts = false; // Close the popup
            this.selectedCosts = [];
          }
        },
        (error) => {
          console.error("API error:", error);
          AppGlobals.ShowErrorMessage(error);
        },
      );
  }

  onPopupShow() {
    // Delay to ensure the grid is created fresh
    (setTimeout(() => {
      this.showGrid = true;
    }),
      1000);
  }

  getRelatedCosts(
    cellData: any,
    columnDate: any,
    projectCostId: any | null,
    shift: string,
    isMoveAll: boolean = false,
  ): void {
    this.selectedShift = shift;
    if (columnDate && typeof columnDate === "string") {
      if (columnDate.includes("-")) {
        const [year, month, day] = columnDate.split("-");
        this.storedColumnDate = `${year}-${month.padStart(
          2,
          "0",
        )}-${day.padStart(2, "0")}`;
      } else {
        this.storedColumnDate = columnDate; // Already in correct format
      }
    }

    this.cellDataStored = cellData;
    // Mirror the projectId resolution used by the shift methods so collapsed group rows work too.
    const source = cellData.groupDisplay
      ? cellData
      : cellData.collapsedItems?.[0] || cellData.items?.[0] || cellData;
    const projectId =
      source.groupDisplay?.projectId ?? projectCostId ?? cellData.id;
    const payload = {
      ProjectId: projectId,
      ColumnDate: this.storedColumnDate, // Use the properly formatted date
      // null category => "shift all cost": list every cost in the column, not just this category
      CategoryId: isMoveAll ? null : cellData.categoryId,
      // These costs get pre-selected and then shifted, so the dialog must not reach past
      // the filter the grid is showing.
      Beauftragt: beauftragtRequestValue(this.beauftragtCode),
      ExcludedDebitorNames: ProjectCostOverview.toRequestNames(
        this.excludedDebitors,
      ),
      Netto: amountBasisIsNetto(this.amountBasisCode),
    };

    this.projectCostsService
      .getProjectCostsLinkedToCategory(payload)
      .then((result: any) => {
        this.showRelatedCosts = true;
        this.linkedCosts = result.details;
        // Safe default: pre-select fixed-date costs; leave milestone-linked costs
        // unchecked so detaching them is always an explicit choice.
        this.selectedCosts = (result.details ?? [])
          .filter((d: any) => !d.dueDateMilestone)
          .map((d: any) => d.costId);
      });
  }

  shiftFourWeek(cellData: any, columnDate: any, selectedCostIds: any[]) {
    const isMoveAll = !selectedCostIds || selectedCostIds[0] === null;

    if (!columnDate || typeof columnDate !== "string") {
      console.error("No valid columnDate provided");
      AppGlobals.ShowErrorMessage("No target date specified");
      return;
    }
    
    let projectCostData = {};

    if (!isMoveAll) {
      projectCostData = {
        projectId: cellData.groupDisplay?.projectId || cellData.id,
        projectCostIds: selectedCostIds,
        columnDate: columnDate,
      };
    } else {
      const source = cellData.groupDisplay
        ? cellData
        : cellData.collapsedItems?.[0] || cellData.items?.[0];

      projectCostData = {
        projectId: source.groupDisplay?.projectId,
        projectCostIds: null,
        columnDate: columnDate,
      };
    }

    this.projectCostsService
      .shiftProjectCostDetailsFourWeeks(projectCostData)
      .then(
        (result) => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } else {
            this.getPageData();
            this.dataGrid.instance.refresh();
            this.notifyShiftSummary(selectedCostIds);
            this.showRelatedCosts = false;
            this.selectedCosts = [];
            this.showRelatedCosts = false;
            this.selectedCosts = [];
          }
        },
        (error) => {
          console.error("API error:", error);
          AppGlobals.ShowErrorMessage(error);
        },
      );
  }

  shiftThreeMonth(cellData: any, columnDate: any, selectedCostIds: any[]) {
    const isMoveAll = !selectedCostIds || selectedCostIds[0] === null;
    let projectCostData = {};

    if (!isMoveAll) {
      projectCostData = {
        projectId: cellData.groupDisplay?.projectId || cellData.id,
        projectCostIds: selectedCostIds,
        columnDate: columnDate,
      };
    } else {
      const source = cellData.groupDisplay
        ? cellData
        : cellData.collapsedItems?.[0] || cellData.items?.[0];

      projectCostData = {
        projectId: source.groupDisplay?.projectId,
        projectCostIds: null,
        columnDate: columnDate,
      };
    }
    this.projectCostsService
      .shiftProjectCostDetailsThreeMonths(projectCostData)
      .then(
        (result) => {
          if (result.hasError === true) {
            AppGlobals.ShowErrorMessage(result.feedback);
          } else {
            this.getPageData();
            this.dataGrid.instance.refresh();
            this.notifyShiftSummary(selectedCostIds);
            this.showRelatedCosts = false; // Close the popup
            this.selectedCosts = [];
          }
        },
        (error) => {
          console.error("API error:", error);
          AppGlobals.ShowErrorMessage(error);
        },
      );
  }

  get hasMilestoneLinkedCosts(): boolean {
    return (this.linkedCosts ?? []).some((c: any) => c.dueDateMilestone);
  }

  private notifyShiftSummary(shiftedIds: any[]): void {
    if (!shiftedIds?.length) return;
    const keptLinked = (this.linkedCosts ?? []).filter(
      (c: any) => c.dueDateMilestone && !shiftedIds.includes(c.costId),
    ).length;
    // Numbers kept outside $localize so the translatable strings stay plain text.
    let msg = `${shiftedIds.length} ${$localize`:@@costsShifted:cost(s) shifted.`}`;
    if (keptLinked > 0) {
      msg += ` ${keptLinked} ${$localize`:@@milestoneCostsKept:milestone-linked cost(s) kept unchanged.`}`;
    }
    notify(msg, "info", 4000);
  }

  showDetails(cellData: any, columnDate: any) {
    const [day, month, year] = columnDate.split("-");
    const apiDateTime = `${year}-${month}-${day}`;

    let projectCostData = {};
    if (cellData.groupDisplay != undefined) {
      projectCostData = {
        projectId: cellData.groupDisplay.projectId,
        columnDate: apiDateTime,
        categoryId: cellData.categoryId,
      };
    } else {
      if (
        cellData.collapsedItems === null ||
        cellData.collapsedItems === undefined
      ) {
        projectCostData = {
          projectId: cellData.items[0].groupDisplay.projectId,
          columnDate: apiDateTime,
        };
      } else {
        projectCostData = {
          projectId: cellData.collapsedItems[0].groupDisplay.projectId,
          columnDate: apiDateTime,
        };
      }
    }
    // The popup breaks down one cell of this grid, so it has to carry the same filter.
    (projectCostData as any).beauftragt = beauftragtRequestValue(
      this.beauftragtCode,
    );
    (projectCostData as any).excludedDebitorNames =
      ProjectCostOverview.toRequestNames(this.excludedDebitors);
    (projectCostData as any).netto = amountBasisIsNetto(this.amountBasisCode);
    this.projectCostsService.getProjectCostDetailsPopup(projectCostData).then(
      (result) => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
        } else {
          this.allDetailsPopup = result.details;
          if (cellData.groupDisplay != undefined) {
            if (cellData.details != "" && cellData.details != null) {
              this.title = `${cellData.groupDisplay.projectName} | ${cellData.details}`;
            } else {
              this.title = `${cellData.groupDisplay.projectName}`;
            }
          } else {
            if (
              cellData.collapsedItems === null ||
              cellData.collapsedItems === undefined
            ) {
              if (
                cellData.items[0].details != "" &&
                cellData.items[0].details != null
              ) {
                this.title = `${cellData.items[0].groupDisplay.projectName} | ${cellData.items[0].details}`;
              } else {
                this.title = `${cellData.items[0].groupDisplay.projectName}`;
              }
            } else {
              if (
                cellData.collapsedItems[0].details != "" &&
                cellData.collapsedItems[0].details != null
              ) {
                this.title = `${cellData.collapsedItems[0].groupDisplay.projectName} | ${cellData.collapsedItems[0].details}`;
              } else {
                this.title = `${cellData.collapsedItems[0].groupDisplay.projectName}`;
              }
            }
          }

          this.popupVisible = true;
        }
      },
      (error) => {
        AppGlobals.ShowErrorMessage(error);
      },
    );
  }

  isCurrentWeekMonday(date: Date): boolean {
    const formattedDate = date.toString();
    const finalDate = formattedDate === this.currentWeek;
    return finalDate;
  }

  exportMenuVisible = false;
  readonly exportMenuItems = [
    { id: "single", text: $localize`:@@exportSingleWorkbook:One Excel file` },
    { id: "zip", text: $localize`:@@exportPerCompanyZip:One file per company (ZIP)` },
  ];

  /** The choice only exists once the zip would kick in; below two Gesellschaften export straight away. */
  onExportClick(): void {
    if ((this.selectedDebitors?.length ?? 0) < 2) {
      this.exportAsExcel(null);
      return;
    }
    this.exportMenuVisible = true;
  }

  onExportMenuItemClick(e): void {
    this.exportMenuVisible = false;
    if (e.itemData.id === "zip") {
      this.exportAsExcel(null);
    } else {
      this.exportCurrentView();
    }
  }

  /** The grid exactly as shown - every ticked Gesellschaft in one workbook, as before v3.10.0. */
  async exportCurrentView(): Promise<void> {
    this.saveExport(await this.buildGridWorkbookBuffer(true), this.exportFileName());
  }

  /**
   * One workbook per selected Schuldner, zipped. Each pass refetches with a single-Schuldner
   * filter and exports the live grid, so the group summaries in every file are that
   * Schuldner's own - re-summing a shared export client-side would not give the same numbers.
   */
  async exportAsExcel(e) {
    const targets = this.selectedDebitors?.length ? [...this.selectedDebitors] : [];

    if (targets.length < 2) {
      const fileName =
        targets.length === 1
          ? this.exportFileName(targets[0])
          : this.exportFileName();
      this.saveExport(await this.buildGridWorkbookBuffer(true), fileName);
      return;
    }

    const grid = this.dataGrid.instance;
    const allKeys = this.debitorOptions.map((o) => o.value);
    const zip = new JSZip();
    const used = new Set<string>();
    grid.beginCustomLoading($localize`:@@exportingCosts:Creating export...`);
    try {
      for (const debitor of targets) {
        // Exclude every other Schuldner rather than including this one, so one pass reads
        // exactly like the filter with a single Gesellschaft ticked.
        await this.getPageData(allKeys.filter((k) => k !== debitor));
        await this.pushDataSourceToGrid();

        // Two Gesellschaften can sanitise to the same name; without this the second
        // would silently replace the first inside the zip. The counter goes on the resolved
        // label, not the key - "__ohne_schuldner__ (2)" no longer matches the sentinel and
        // would leak the internal name into the file.
        const label = this.debitorFileLabel(debitor);
        let name = this.exportFileName(debitor);
        for (let n = 2; used.has(name); n++) {
          name = this.exportFileName(`${label} (${n})`);
        }
        used.add(name);

        zip.file(name, (await this.buildGridWorkbookBuffer()) as any);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
      return;
    } finally {
      // First, so a failure in either restore call cannot leave the overlay covering the grid.
      grid.endCustomLoading();
      try {
        await this.getPageData();
        await this.pushDataSourceToGrid();
      } catch {
        // The export already failed or finished; a failed restore must not mask that.
      }
    }

    const blob = await zip.generateAsync({ type: "blob" });
    const zipName = this.exportFileName().replace(/\.xlsx$/, ".zip");
    saveAs(blob, zipName);
    this.loggingService.logFileExport(await blob.arrayBuffer(), zipName, {
      section: ActivitySection.COST_OVERVIEW,
    });
  }

  /**
   * getPageData assigns a new projectList, which normally reaches the grid through the
   * [dataSource] input on the next change-detection tick. The export loop never yields to
   * Angular, so it hands the array over itself - otherwise a workbook can be built from the
   * previous Gesellschaft's rows and shipped under this one's name.
   */
  private async pushDataSourceToGrid(): Promise<void> {
    this.dataGrid.instance.option("dataSource", this.projectList);
    await this.refreshGrid();
  }

  /**
   * DevExtreme rejects a pending load with the string "canceled" as soon as a newer one
   * supersedes it - measured, not assumed: writing the dataSource option during a refresh, or
   * starting a second refresh, rejects the first. Both happen here, because getPageData fires
   * its own refresh and the [dataSource] binding is re-applied whenever change detection runs
   * between the export loop's awaits.
   *
   * A superseded refresh is not a failure; the newer load is the one whose rows the export
   * wants. Before this, it surfaced to the user as "FEHLER: canceled" and abandoned the export.
   */
  private async refreshGrid(attempts = 3): Promise<void> {
    const grid = this.dataGrid.instance;
    for (let attempt = 1; ; attempt++) {
      try {
        await grid.refresh();
        return;
      } catch (error) {
        // Only cancellation is retried. A real load failure still stops the export.
        if (error !== "canceled" || attempt >= attempts) {
          throw error;
        }
      }
    }
  }

  /** Blank cells read as "failed to load"; the filter already names this bucket. */
  debitorCellText = (cellInfo: any): string =>
    cellInfo?.value ? cellInfo.value : this.noDebitorLabel;

  /** Company names reach the filesystem and the zip index, and may hold path characters. */
  private debitorFileLabel(debitor: string): string {
    const name =
      debitor === ProjectCostOverview.NO_DEBITOR_KEY ? this.noDebitorLabel : debitor;
    return name.replace(/[\\/:*?"<>|]/g, "-").trim() || "Export";
  }

  private saveExport(buffer: ArrayBuffer, fileName: string): void {
    saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName);
    this.loggingService.logFileExport(buffer, fileName, {
      section: ActivitySection.COST_OVERVIEW,
    });
  }

  /** Hides zeros, so a formula cell over an empty week stays as blank as the grid shows it. */
  private static readonly EURO_FORMAT = "#,##0.00 [$€-0407];-#,##0.00 [$€-0407];";

  private static readonly COST_LIST_SHEET = $localize`:@@costListSheet:Cost list`;

  /** Project and category of a grid row, as one key. The list is filtered by it. */
  private static rowKey(project: string, category: string): string {
    return `${project}\u0000${category}`;
  }

  /**
   * One row per cost the grid sheet actually holds - costItems narrowed to the exported
   * project/category rows, so a search term cannot leave costs in the list (and thus in the
   * Total and project SUMIFS) that the grid sheet does not show.
   * Columns A-H; buildGridWorkbookBuffer's SUMIFS formulas read A, B, G and H by letter.
   */
  private addCostListSheet(workbook: ExcelJS.Workbook, exportedRows: Set<string>): void {
    const sheet = workbook.addWorksheet(ProjectCostOverview.COST_LIST_SHEET);
    sheet.columns = [
      { header: $localize`:@@costListProject:Project`, width: 40 },
      { header: $localize`:@@costListCategory:Category`, width: 25 },
      { header: $localize`:@@responsibleUser:Responsible User`, width: 22 },
      { header: $localize`:@@costListCompany:Company`, width: 30 },
      { header: $localize`:@@commissioned:Commissioned`, width: 14 },
      { header: $localize`:@@costListDueDate:Due date`, width: 13, style: { numFmt: "dd.MM.yyyy" } },
      { header: $localize`:@@costListWeek:Week`, width: 13, style: { numFmt: "dd.MM.yyyy" } },
      { header: $localize`:@@costListAmount:Amount`, width: 16, style: { numFmt: ProjectCostOverview.EURO_FORMAT } },
    ];
    // "yyyy-MM-dd" as UTC midnight, the same instant getDateFromDateString gives the grid's
    // week headers - SUMIFS matches the week column against those cells by exact value.
    const utc = (iso: string) => {
      const [y, m, d] = iso.split("-").map(Number);
      return new Date(Date.UTC(y, m - 1, d));
    };
    const items = this.costItems.filter((item) =>
      exportedRows.has(ProjectCostOverview.rowKey(item.projectName, item.category)),
    );
    items.forEach((item, i) => {
      const r = i + 2;
      // The API sends 0001-01-01 for a cost without a due date. Its week is then a fixed value:
      // a WEEKDAY formula over that date recalculates to a day no grid column has, and the
      // money would vanish from the grid sheet on open.
      const undated = item.dueDate.startsWith("0001-");
      sheet.addRow([
        item.projectName,
        item.category,
        item.responsibleUser,
        item.debitor || this.noDebitorLabel,
        item.beauftragt,
        undated ? null : utc(item.dueDate),
        // A formula, so moving a due date in the list moves the money in the grid sheet.
        undated
          ? utc(item.week)
          : { formula: `F${r}-WEEKDAY(F${r},3)`, result: utc(item.week) },
        item.amount,
      ]);
    });
    sheet.autoFilter = { from: "A1", to: "H1" };
    sheet.views = [{ state: "frozen", ySplit: 1 }];
  }

  /** A SUMIFS criterion that matches the text exactly, not as a pattern or comparison. */
  private static exactCriterion(text: string): string {
    const escaped = (text ?? "").replace(/[~*?]/g, "~$&").replace(/"/g, '""');
    return `"=${escaped}"`;
  }

  /**
   * withList: the workbook also carries the cost list, and every euro cell of the grid sheet
   * is SUMIFS over it rather than a typed-in number - so the grid can be re-cut or edited in
   * Excel. The zip's per-Gesellschaft files keep plain numbers.
   */
  private async buildGridWorkbookBuffer(withList = false): Promise<ArrayBuffer> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet($localize`Project Cost List`);
    // No items (an API without the list) means plain values: formulas over an empty list
    // would recalculate every amount to 0 on open.
    const list = withList && this.costItems.length ? ProjectCostOverview.COST_LIST_SHEET : null;
    const col = (c: string) => `'${list?.replace(/'/g, "''")}'!$${c}:$${c}`;
    let headerRow = 1;
    const exportedRows = new Set<string>();
    // A project group row's summary cells do not carry the group key, only its own first cell
    // does - so they are collected here and get their formula once the whole row is known.
    const projectOfRow = new Map<number, string>();
    const sums: { cell: any; criteria: string[]; projectRow?: number; cached: number }[] = [];

    await exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: (options) => {
        const { gridCell, excelCell } = options;
        const isWeek = this.dates.includes(gridCell.column?.dataField);

        if (gridCell.rowType === "header") {
          headerRow = Number(excelCell.row);
        }
        if (gridCell.rowType === "data") {
          exportedRows.add(
            ProjectCostOverview.rowKey(gridCell.data.groupDisplay?.projectName, gridCell.data.category),
          );
        }
        if (gridCell.rowType === "group" && gridCell.groupIndex === 1 && !isWeek && typeof gridCell.value === "string") {
          projectOfRow.set(Number(excelCell.row), gridCell.value);
        }

        if (list && isWeek && (gridCell.rowType === "data" || gridCell.rowType === "group")) {
          const week = `${excelCell.address.replace(/\d+$/, "")}$${headerRow}`;
          const sum = {
            cell: excelCell,
            criteria: [`${col("G")},${week}`],
            projectRow: undefined as number | undefined,
            cached:
              (gridCell.rowType === "data"
                ? gridCell.value
                : gridCell.groupSummaryItems?.[0]?.value) ?? 0,
          };
          if (gridCell.rowType === "data") {
            sum.criteria.push(
              `${col("A")},${ProjectCostOverview.exactCriterion(gridCell.data.groupDisplay?.projectName)}`,
              `${col("B")},${ProjectCostOverview.exactCriterion(gridCell.data.category)}`,
            );
          } else if (gridCell.groupIndex === 1) {
            sum.projectRow = Number(excelCell.row);
          }
          // groupIndex 0 is the "Total" row: the week alone.
          sums.push(sum);
          return;
        }

        if (
          gridCell.rowType === "group" &&
          !gridCell.groupSummaryItems?.filter((item) => item.value != 0)
        ) {
          const value = gridCell.value;
          excelCell.value = value;
        }

        if (
          gridCell.rowType === "group" &&
          gridCell.groupSummaryItems?.filter((item) => item.value != 0).length >
          0
        ) {
          const value = gridCell.groupSummaryItems[0].value;
          excelCell.value = value;
          excelCell.numFmt = "#,##0.00 [$€-0407]";
        }

        // Week columns only. visibleIndex > 3 also caught the hidden spacer column, whose header
        // became NaN - and Excel offered to "repair" every export because of that one cell.
        if (gridCell.rowType === "header" && isWeek) {
          const value = gridCell.column.name;
          const formattedValue = this.getDateFromDateString(value);

          excelCell.numFmt = "dd.MM.yyyy";
          excelCell.value = formattedValue;
        }
        if (gridCell.rowType === "data" && gridCell.column.visibleIndex > 3) {
          const value = gridCell.value;
          excelCell.value = value;
          excelCell.numFmt = "#,##0.00 [$€-0407]";
        }
      },
    });

    if (list) {
      this.addCostListSheet(workbook, exportedRows);
    }
    for (const sum of sums) {
      if (sum.projectRow !== undefined) {
        sum.criteria.push(
          `${col("A")},${ProjectCostOverview.exactCriterion(projectOfRow.get(sum.projectRow))}`,
        );
      }
      sum.cell.value = {
        formula: `SUMIFS(${col("H")},${sum.criteria.join(",")})`,
        result: sum.cached,
      };
      sum.cell.numFmt = ProjectCostOverview.EURO_FORMAT;
    }

    if (list) {
      // The cached results are only what the API sent; let Excel own the numbers from here.
      workbook.calcProperties.fullCalcOnLoad = true;
    }
    return workbook.xlsx.writeBuffer() as Promise<ArrayBuffer>;
  }

  /**
   * Projektkosten_<date>_<filter>[_<Gesellschaft>].xlsx - one convention for every file this
   * page produces, so a per-Gesellschaft workbook still sorts next to a plain export.
   */
  private exportFileName(debitor?: string): string {
    const today = new Date().toISOString().slice(0, 10);
    const stem =
      `Projektkosten_${today}_${beauftragtFileSlug(this.beauftragtCode)}` +
      `_${amountBasisFileSlug(this.amountBasisCode)}`;
    return debitor === undefined
      ? `${stem}.xlsx`
      : `${stem}_${this.debitorFileLabel(debitor)}.xlsx`;
  }

  getDateFromDateString(dateString: string) {
    if (dateString != undefined || dateString != null) {
      const [day, month, year] = dateString?.split("-");
      
      return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    }
  }

  saveExcelBufferToFile(buffer, filename) {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  ds: any = [];
  async getFilteredAndSortedData() {
    let grid = this.dataGrid.instance;
    let filterExpr = grid?.getCombinedFilter(true);
    const dataSource = grid?.getDataSource();
    const loadOptions = dataSource?.loadOptions();

    this.ds = await dataSource?.store().load({
      filter: filterExpr,
      sort: loadOptions?.sort,
      group: loadOptions?.group,
    });
    // this.calculateTotals();
  }

  calculateTotals() {
    let totals = {};
    this.dates.forEach((date) => {
      totals[date] = 0;
    });
    this.ds.forEach((projectGroup) => {
      if (projectGroup.collapsedItems != undefined) {
        projectGroup.collapsedItems.forEach((project) => {
          this.dates.forEach((date) => {
            totals[date] += project[date] || 0;
          });
        });
      }
      if (projectGroup.items != undefined) {
        projectGroup.items.forEach((project) => {
          this.dates.forEach((date) => {
            totals[date] += project[date] || 0;
          });
        });
      }
    });

    this.totals = totals;
  }

  calculateTotalForColumn(dataKey: any, e: any): any {
    // var total = 0;
    // let projectsListFiltered = []

    // this.ds.forEach(projectGroup => {
    //   if (projectGroup.items != undefined) {
    //     projectGroup.items.forEach(project => {
    //       projectsListFiltered.push(project);
    //     })
    //   } else {
    //     projectsListFiltered = this.ds;
    //   }
    // })
    // projectsListFiltered.forEach(item => {
    //   if (item.hasOwnProperty(dataKey) && dataKey !== 'id' && dataKey !== 'details' && dataKey !== 'groupDisplay' && dataKey !== 'key' && dataKey !== 'costDict' && dataKey !== 'category' && dataKey !== 'date' && dataKey !== 'cost') {
    //     if (this.dates[e] === dataKey) {
    //       total += item[dataKey];
    //     }
    //   }
    // });

    let stringTotal = this.formatEuro(this.totals[dataKey]);

    return stringTotal;
  }

  dateDatafeilds: any = [];
  getDataField(data: string, i: any): any {
    if (!this.dateDatafeilds.includes(data)) {
      this.dateDatafeilds.push(data);
      if (data.toString() != undefined) return data.toString();
    }
  }

  getDataValue(data: string, i: any): any {
    var total = 0;
    this.projectList.forEach((item) => {
      if (
        item.hasOwnProperty(data) &&
        data !== "id" &&
        data !== "details" &&
        data !== "groupDisplay" &&
        data !== "key" &&
        data !== "costDict" &&
        data !== "category" &&
        data !== "date" &&
        data !== "cost" &&
        data !== "summaryId"
      ) {
        if (this.dates[i] === data) {
          total = item[data];

          let dataTotal = this.formatEuro(total);
          return dataTotal;
        }
      }
    });
  }

  printData(thisData: any): any {
    //.costDict[Object.keys(thisData.costDict)[0]]
    return thisData.costDict[Object.keys(thisData.costDict)[0]];
  }

  printGroupTotals(data: any) {
    return data.toString();
  }

  onCalculateCustomSummary(e) {
    if (e.summaryProcess === "start") {
      // Initialize total value
      e.totalValue = [];
    }

    if (e.summaryProcess === "calculate") {
      // Push each cell value into an array to access all the values later
      e.totalValue.push(e.value);
    }

    if (e.summaryProcess === "finalize") {
      // Optionally process the collected values
      // For example, sum them if they are numeric
      let sum = 0;
      e.totalValue.forEach((value) => {
        const numericValue = parseFloat(value.replace(/[^\d.-]/g, "")); // Convert string to number
        if (!isNaN(numericValue)) {
          sum += numericValue;
        }
      });

      e.totalValue = sum; // Set the total value to the sum
    }
  }

  returnValue(e) { }

  calculateTotalsForGoup(e) { }

  printCellValue(date: string, data: any): any {
    if (Object.keys(data.costDict)[0] === date) {
      return this.printData(data);
    }
  }

  onCellPrepared(e: any) {

    if (e.rowType == "group") {
      if (e.rowIndex == 0) {
        
        e.cellElement.style.fontWeight = "700";
        e.cellElement.style.height = "60px";
        e.cellElement.style.verticalAlign = "middle";
        if (e.columnIndex == 0) {
          e.cellElement.children[0].style.display = "none";
        }
      }
      else {
        if (
          (['data', 'group', 'totalFooter', 'groupFooter'].includes(e.rowType)) &&
          e.column &&
          this.isCurrentWeek(e.column.dataField)
        ) {
          e.cellElement.classList.add('current-week-column');
        }
      }
    }
  }

  // onCellPrepared(e: any) {
  //   // For all rows where column info is available
  //   if (
  //     (['data', 'group', 'totalFooter', 'groupFooter'].includes(e.rowType)) &&
  //     e.column &&
  //     this.isCurrentWeek(e.column.dataField)
  //   ) {
  //     e.cellElement.classList.add('current-week-column');
  //   }
  //   if (e.rowType === "group row") {
  //     e.cellElement.style.fontWeight = "700";
  //     e.cellElement.style.backgroundColor = "#ececec";
  //     e.cellElement.style.height = "60px";
  //     e.cellElement.style.verticalAlign = "middle";
  //   }
  // }

  isCurrentWeek(date: string): boolean {
    // date is in "dd-MM-yyyy" format
    return date === this.currentWeek;
  }
  formatDate(cellInfo: any) {
    if (cellInfo.value) {
      return cellInfo.value.split("/").join(".");
    }
    return cellInfo.value;
  }
}